/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Loud_Mantis_BoilInputs */

const fr_salty_loud_mantis_boil = /** @type {(inputs: Salty_Loud_Mantis_BoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes séances favorites`)
};

/**

* @param {Salty_Loud_Mantis_BoilInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_loud_mantis_boil = /** @type {((inputs?: Salty_Loud_Mantis_BoilInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Loud_Mantis_BoilInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_loud_mantis_boil(inputs)
});